import React from 'react';
import { get } from 'lodash-es';
import { connect } from 'react-redux';
import { AppraisalTabsContextProvider } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';
import { AppraisalTabsLayout } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/appraisal-tabs-layout';

export function AppraisalTabsContainerUI(props) {
  return <AppraisalTabsContextProvider {...props} WrappedComponent={AppraisalTabsLayout} />;
}

export const mapStateToProps = state => ({
  isMobile: get(state, 'mobile'),
  location: get(state, 'pageContext.location'),
  referer: get(state, 'pageContext.page.referer'),
  profileOfferVin: get(state, 'profile.data.idm.appraisalOffersHistory[0].vin'),
  isAppExtensionPage: get(state, 'pageContext.isAppExtensionPage'),
});

export const AppraisalTabsContainer = connect(mapStateToProps)(AppraisalTabsContainerUI);
